interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => onChange(1)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            1
          </button>
          <span className="px-1 text-foreground-400">…</span>
        </>
      )}
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`flex h-9 w-9 items-center justify-center rounded-md border text-sm transition-colors ${
            item === page
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {item}
        </button>
      ))}
      {end < totalPages && (
        <>
          <span className="px-1 text-foreground-400">…</span>
          <button
            type="button"
            onClick={() => onChange(totalPages)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            {totalPages}
          </button>
        </>
      )}
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="flex h-9 items-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}